import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac42308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = {
  class: "main-content",
  style: {"min-height":"434px"}
}
const _hoisted_3 = { class: "prev-question" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-up" }, null, -1))
const _hoisted_5 = { class: "next-question_text" }
const _hoisted_6 = { class: "question-content" }
const _hoisted_7 = { class: "button-info-link" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-info" }, null, -1))
const _hoisted_9 = { class: "button-bar" }
const _hoisted_10 = { class: "button-blue" }
const _hoisted_11 = { class: "button-blue" }
const _hoisted_12 = { class: "next-question" }
const _hoisted_13 = { class: "prev-question_text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-down" }, null, -1))

import SkeletonTextPlaceholder from '@/components/generic/SkeletonTextPlaceholder';
	import SkeletonBlock from '@/components/generic/SkeletonBlock';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkeletonCheck',
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SkeletonBlock), { transparent: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "6" })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h4", null, [
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "20" })
            ]),
            _createElementVNode("h1", null, [
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "30" }),
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "20" })
            ]),
            _createElementVNode("a", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "12" })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", _hoisted_10, [
                _createVNode(_unref(SkeletonTextPlaceholder), { length: "2" })
              ]),
              _createElementVNode("button", _hoisted_11, [
                _createVNode(_unref(SkeletonTextPlaceholder), { length: "3" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_unref(SkeletonTextPlaceholder), { length: "8" })
            ]),
            _hoisted_14
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})